import { motion } from "framer-motion";

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
};

export const Welcome = ({ t }) => (
  <section className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-36" data-testid="welcome-section">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <motion.div {...fadeUp} className="lg:col-span-5 relative">
        <div className="absolute -top-5 -left-5 w-full h-full border border-taupe/40 pointer-events-none" />
        <img
          src="/images/team-table.webp"
          alt="Private Assistenz Schweiz – Team bei der persönlichen Beratung"
          className="w-full h-[460px] md:h-[560px] object-cover object-[50%_15%]"
          data-testid="welcome-image"
        />
      </motion.div>

      <div className="lg:col-span-7">
        <motion.p {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-bold text-taupe mb-6" data-testid="welcome-overline">
          {t.welcome.overline}
        </motion.p>
        <motion.h2
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.1 }}
          className="font-heading font-light tracking-tight text-4xl md:text-5xl leading-[1.05]"
          data-testid="welcome-title"
        >
          {t.welcome.title}
        </motion.h2>
        <motion.p
          {...fadeUp}
          transition={{ ...fadeUp.transition, delay: 0.2 }}
          className="mt-8 text-smoke text-base md:text-lg font-light leading-relaxed max-w-2xl"
          data-testid="welcome-body"
        >
          {t.welcome.body}
        </motion.p>

        <div className="mt-12 grid grid-cols-3 gap-6 border-t border-line pt-8">
          {t.welcome.stats.map((s, i) => (
            <motion.div
              key={s.label}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: 0.25 + i * 0.1 }}
              data-testid={`welcome-stat-${i}`}
            >
              <p className="font-heading text-3xl md:text-4xl font-medium text-ink">{s.value}</p>
              <p className="mt-2 text-xs md:text-sm text-smoke tracking-wide">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
